export const USER_PERMISSIONS_MODAL = {
  AVAILABLE_TEAMS_LABEL: { key: 'AVAILABLE_TEAMS_LABEL', value: 'Available Teams' },
  ACCESSIBLE_TEAMS_LABEL: { key: 'ACCESSIBLE_TEAMS_LABEL', value: 'Accessible Teams' },
  READ_CHECKBOX_LABEL: { key: 'READ_CHECKBOX_LABEL', value: 'Read' },
  WRITE_CHECKBOX_LABEL: { key: 'WRITE_CHECKBOX_LABEL', value: 'Write' },
  SEARCH_BUTTON: { key: 'SEARCH_BUTTON', value: 'Search' },
  CLEAR_BUTTON: { key: 'CLEAR_BUTTON', value: 'Clear' },
  SEARCH_TEAM_PLACEHOLDER: { key: 'SEARCH_TEAM_PLACEHOLDER', value: 'Search team name' },
};
